import React from 'react'
import "../../styles/footer.css"
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <>
        <div className="page-wrapper">
            <footer>
                <div className="footer-bottom">

                    <div className="seccion-1-3">
                        <nav id="footer-navigation" className="footer-navigation" role="navigation">
                            <ul id="footer-menu" className="clearfix inline-inside">
                                <li><Link to="/nuestros-clientes">Nuestros clientes</Link></li>
                                <li><Link to="/nuestra-firma">Politicas de calidad</Link></li>
                            </ul>
                        </nav>
                    </div>

                    <div className="seccion-1-3">
                        <nav id="footer-navigation" className="footer-navigation" role="navigation">
                            <ul id="footer-menu" className="clearfix inline-inside">
                                <li><Link to="/ventajas">Ventajas al suscribirse</Link></li>
                                <li><Link to="/registrarse">Suscribirse</Link></li>
                            </ul>
                        </nav>
                    </div>

                    <div className="seccion-1-3">
                        <nav id="footer-navigation" className="footer-navigation">
                            <ul id="footer-menu" className="clearfix inline-inside">
                                <li className='footer-li'>© 2023 Todos los derechos reservados tributosyfinanzas.com</li>
                            </ul>
                        </nav>
                    </div>

                    <div className="seccion-1-3">
                        <a className='social-footer' href="https://wa.me/3188217116" target='blank'><i className="fab fa-whatsapp"></i></a>
                        <a className='social-footer' href="https://www.facebook.com/profile.php?id=61552338819531" target='blank'><i className="fab fa-facebook"></i></a>
                        <a className='social-footer' href="https://www.instagram.com/impuestosmunicipales23/" target='blank'><i className="fab fa-instagram"></i></a>
                        <a className='social-footer' href="https://twitter.com/nommbreusuario" target='blank'><i className="fab fa-twitter"></i></a>
                        <a className='social-footer' href="https://www.linkedin.com/in/nommbreusuario" target='blank'><i className="fab fa-linkedin"></i></a>
                        <a className='social-footer' href="https://www.youtube.com/channel/UCh91SYAS4QN8q8xkVJ_wq2w" target='blank'><i className="fa-brands fa-youtube"></i></a>
                    </div>

                </div>
            </footer>
        </div>
    </>
  )
}

export default Footer